var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5005 9.49565C17.1491 11.4902 16.8283 13.4808 17 15.5C17.0747 16.3778 17.6057 17.7183 18 18.5C18.3943 19.2812 19.1558 19.8726 20 20C21.0016 20.1522 21.3892 19.9723 22 21C22.3019 21.5082 21.9314 22.4548 21.4283 22.7479C20.8278 23.0983 20.1562 22.9952 19.5015 22.9513C18.4464 22.8804 17.2265 22.9653 16.2185 22.5953C15.4126 22.2994 14.8242 21.5887 14.3253 20.8714C13.8274 20.1546 13.363 19.3837 12.67 18.8662C12.0746 18.4205 11.3965 18.2814 10.7511 17.9543C9.84487 17.4942 8.67402 16.6234 9.08515 15.4273C9.24755 14.9551 10.6743 13.371 11 13C12.3155 11.5034 12.2575 10.7892 13.1605 9",
    stroke: "#07133F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.a038d9a1cbb219672007db0bd810a629.svg";
export { ForwardRef as ReactComponent };